// Count, total with tax, and the split by context for whatever is filtered.
// FIG / Personal / other count only a context a person chose; the rest is
// "not confirmed". Purchases and payments (a tax payment, a fee) apart, then
// the tax figures, which are purchases only: items before tax + tax + tips +
// no tax line = purchases with tax. The context band covers everything.
import { usd } from './money';

const PARTS = [
  { key: 'FIG', label: 'FIG', color: '#4B0082' },
  { key: 'Personal', label: 'Personal', color: '#2e8b57' },
  { key: 'other', label: 'Other', color: '#b8860b' },
  { key: 'unconfirmed', label: 'Not confirmed', color: '#c8bba8' },
];

export default function SummaryStrip({ summary }) {
  if (!summary) return null;
  const total = summary.total || 0;
  const t = summary.tax || null;
  const p = summary.purchases || null;
  const pay = summary.payments || null;
  const count = (n) => <span className="rc-fig-count">· {n} receipt{n === 1 ? '' : 's'}</span>;
  return (
    <div className="rc-strip" role="group" aria-label="Summary">
      <div className="rc-strip-main">
        <strong>{summary.receipts}</strong> receipt{summary.receipts === 1 ? '' : 's'}
        {summary.receiptsWithoutTotal ? <span className="rc-note"> · {summary.receiptsWithoutTotal} without a total</span> : null}
      </div>
      {/* Purchases and payments apart only when there are payments: with none, purchases are the total (never a $0.00 figure). */}
      {p && pay && pay.receipts > 0 && (
        <div className="rc-strip-figs">
          <span><span className="rc-fig-label">Purchases</span><strong>{usd(p.total)} {count(p.receipts)}</strong></span>
          <span><span className="rc-fig-label">Payments</span><strong>{usd(pay.total)} {count(pay.receipts)}</strong></span>
          <span><span className="rc-fig-label">Total</span><strong>{usd(summary.total)} {count(summary.receipts)}</strong></span>
        </div>
      )}
      <div className="rc-strip-figs">
        <span><span className="rc-fig-label">Items before tax</span><strong>{t && t.receipts ? usd(t.itemsBeforeTax) : '—'}</strong></span>
        <span><span className="rc-fig-label">Tax</span><strong>{t && t.receipts ? usd(t.tax) : '—'}</strong></span>
        {/* Read left to right as a sum: items before tax + tax + tips + no tax line = total with tax. */}
        {t && t.tips?.receipts > 0 && (
          <span><span className="rc-fig-label">Tips</span><strong>{usd(t.tips.total)} <span className="rc-fig-count">· {t.tips.receipts} receipt{t.tips.receipts === 1 ? '' : 's'}</span></strong></span>
        )}
        {t && t.noTaxLine.receipts > 0 && (
          <span><span className="rc-fig-label">No tax line</span><strong>{usd(t.noTaxLine.total)} <span className="rc-fig-count">· {t.noTaxLine.receipts} receipt{t.noTaxLine.receipts === 1 ? '' : 's'}</span></strong></span>
        )}
        {pay && pay.receipts > 0
          ? <span><span className="rc-fig-label">Purchases with tax</span><strong>{usd(p.total)}</strong></span>
          : <span><span className="rc-fig-label">Total with tax</span><strong>{usd(summary.total)}</strong></span>}
      </div>
      {total > 0 && (
        <div className="rc-band" aria-hidden="true">
          {PARTS.map((p) => (summary.byContext[p.key].total > 0 ? <span key={p.key} style={{ width: `${(summary.byContext[p.key].total / total) * 100}%`, background: p.color }} /> : null))}
        </div>
      )}
      <div className="rc-legend">
        {PARTS.filter((p) => summary.byContext[p.key].receipts > 0).map((p) => (
          <span key={p.key}><span className="rc-dot" style={{ background: p.color }} />{p.label} <strong>{usd(summary.byContext[p.key].total)}</strong> · {summary.byContext[p.key].receipts}</span>
        ))}
      </div>
    </div>
  );
}
